export default "__VITE_ASSET__CSjnhIcg__"